/* istanbul ignore file */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLocaleLanguage } from "../Helper";
import { buildDetectionOptions } from "./detectionOptions";
import { buildTranslationLoadPath } from "./translationLoadPath";

const detectionOptions = buildDetectionOptions(window.location.pathname);

if (process.env.NODE_ENV === 'test') {
    i18n
        .use(initReactI18next)
        .init({
            debug: false,
            lng: 'en',
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false
            },
            resources: {
                en: { translation: {} }
            },
            react: {
                bindI18n: 'languageChanged',
                bindI18nStore: '',
                transEmptyNodeValue: '',
                transSupportBasicHtmlNodes: true,
                transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
                useSuspense: false,
            }
        });
/* istanbul ignore next */
} else {
    i18n
        .use(Backend)
        .use(LanguageDetector)
        .use(initReactI18next) // passes i18n down to react-i18next
        .init({
            debug: false,
            detection: detectionOptions,
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false // react already safes from xss
            },
            backend: {
                loadPath: buildTranslationLoadPath
            },
            react: {
                bindI18n: 'languageChanged',
                bindI18nStore: '',
                transEmptyNodeValue: '',
                transSupportBasicHtmlNodes: true,
                transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
                useSuspense: false,
            }
        })
        .then(() => {
            const lang = getLocaleLanguage(i18n.language);
            i18n.changeLanguage(lang);
        });
}

export default i18n;
